import React from 'react';
import PropTypes from 'prop-types';

const CasinoNumbers = ({ numbers }) => numbers.length ? (
    <div className="outgoing-numbers-wrapper">
        <div className='outgoing-numbers-wrap'>
            <p className='result'>Result</p>
            <ul className="outgoing-numbers">
                {numbers.map(number => <li key={number}>
                    <span>{number}</span>
                </li>)}
            </ul>
        </div>
    </div>
) : null;

CasinoNumbers.propTypes = {
    numbers: PropTypes.array.isRequired,
};

export default CasinoNumbers;